import ApiRequest from '../util/ApiRequest'

export default class Badge {
    getAll = async () => {
        return await ApiRequest.set('v1/badges', 'GET')
    }

    getActive = async () => {
        return await ApiRequest.set('v1/badges/active', 'GET')
    }

    getInactive = async () => {
        return await ApiRequest.set('v1/badges/inactive', 'GET')
    }

    getById = async (badge_id) => {
        return await ApiRequest.set(`v1/badges/${badge_id}`, 'GET')
    }
}
